/**
 * @author Vladislav Urbánek <urbanek.vlada@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import ViewerLifeCycle from './viewer-life-cycle';

/**
 * Továrna pro stavový automat životního cyklu.
 */
export default class ViewerLifeCycleFactory {
  /**
   * Vytvoří nový stavový automat životního cyklu.
   * @returns {import('./viewer-life-cycle').default} Vytvořený stavový automat.
   */
  create() {
    return new ViewerLifeCycle();
  }
}
